// Translations
import { CONTINUE_PROOF_INCOME_METHOD_BUTTON } from 'components/landing-options/handlers/translations/landing-options.handlers.translations';
// Types
import {
  CloseLandingMethodModalEventHandlerType,
  LandingOptionsBuilderHandlersType,
  LandingOptionsMethodsHandlersType,
  OpenLandingMethodModalEventHandlerType,
  SetupLandingOptionsLayoutButtonConfigurationHandlerType,
} from 'components/landing-options/handlers/types/landing-options.handlers.type';

const closeLandingMethodModalEventHandler = <T>({
  onCloseModal,
  selectedMethod,
  setShowMethodModal,
}: CloseLandingMethodModalEventHandlerType<T>): void => {
  onCloseModal?.(selectedMethod as string);
  setShowMethodModal(false);
};

const openLandingMethodModalEventHandler = <T>({
  onContinueToModal,
  onOpenModal,
  selectedMethod,
  setShowMethodModal,
}: OpenLandingMethodModalEventHandlerType<T>): void => {
  onContinueToModal?.(selectedMethod as string);
  onOpenModal?.(selectedMethod as string);
  setShowMethodModal(true);
};

const setupLandingOptionsLayoutButtonConfigurationHandler = <T>({
  formatMessage,
  onOpenModal,
  onContinueToModal,
  setMainButtonConfiguration,
  selectedMethod,
  setShowMethodModal,
}: SetupLandingOptionsLayoutButtonConfigurationHandlerType<T>): void => {
  setMainButtonConfiguration({
    children: formatMessage({ id: CONTINUE_PROOF_INCOME_METHOD_BUTTON }),
    disabled: !selectedMethod,
    onClick: () =>
      openLandingMethodModalEventHandler<T>({
        onContinueToModal,
        onOpenModal,
        selectedMethod,
        setShowMethodModal,
      }),
  });
};

const LandingOptionsHandlers = <T>({
  formatMessage,
  modalConfiguration: { onOpenModal, onContinueToModal, onCloseModal },
  setShowMethodModal,
  selectedMethod,
  setMainButtonConfiguration,
}: LandingOptionsBuilderHandlersType<T>): LandingOptionsMethodsHandlersType => ({
  handleCloseLandingMethodModalEvent: () =>
    closeLandingMethodModalEventHandler({
      onCloseModal,
      selectedMethod,
      setShowMethodModal,
    }),
  handleSetupLandingOptionsLayoutButtonConfiguration: () =>
    setupLandingOptionsLayoutButtonConfigurationHandler({
      formatMessage,
      onOpenModal,
      onContinueToModal,
      selectedMethod,
      setMainButtonConfiguration,
      setShowMethodModal,
    }),
});

export { LandingOptionsHandlers };
